export function yuanFromCents(value) {
  const cents = Number(value || 0);
  if (!Number.isFinite(cents)) {
    return 0;
  }
  return Number((cents / 100).toFixed(2));
}

export function formatYuan(value) {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount)) {
    return "0";
  }
  return amount.toFixed(2).replace(/\.?0+$/, "");
}

export function formatYuanFromCents(value) {
  return formatYuan(yuanFromCents(value));
}
